import React from 'react'

import './style.scss'

const noop = () => {}

export default function VeryNiceButton ({
  children, // Content
  type = null, // Color
  isBold = true, // Font weight bold
  isTall = false, // Fill parent height
  isFlat = false, // No background
  isSaving = false, // Show spinner
  isInline = false, // Don't fill width
  isOutlined = false, // Show color border
  isDisabled = false, // Disable state
  onClick = noop
}) {
  const _disabled = isSaving || isDisabled

  const className = [
    'very-nice-button',
    isBold ? 'is-bold' : null,
    isTall ? 'is-tall' : null,
    isFlat ? 'is-flat' : null,
    type ? `type-${type}` : null,
    isInline ? 'is-inline' : null,
    isOutlined ? 'is-outlined' : null,
    (_disabled) ? 'is-disabled' : null,
  ].filter(name => name)
  .join(' ')

  const handleUserKeyPress = (e) => {
    if (e.keyCode === 13 || e.keyCode === 32) {
      onClick();
    }
  };

  return (
    <div
      className={className}
      data-testid="very-nice-button"
      onClick={_disabled ? noop : onClick}
      onKeyUp={handleUserKeyPress}
      tabIndex="0"
    >
      { isSaving ? 'Saving...' : children }
    </div>
  )
}